import React, { useEffect, useState, useCallback } from 'react';
import { Card, CardHeader } from 'reactstrap';
import Select from 'react-select';
import PSO from '../../../services/PSO';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import Strings from '../../../translations/Translations';
import { useLocation } from 'react-router-dom';

import AnalyzeGeneral from './components/AnalyzeGeneral';
import AnalyzeSpecific from './components/AnalyzeSpecific';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function AnalyzeModule() {
  const { authenticated, toggleLoading, currentCampaign } = useAuth();
  const [selectedOption, setSelectedOption] = useState();
  const [options, setOptions] = useState();
  const [its, setIts] = useState();
  const [currentIt, setCurrentIt] = useState();
  const [totals, setTotals] = useState();

  const query = useQuery();

  const loadCounters = useCallback((localIts) => {
    let rlikes = 0;
    let rhits = 0;
    let rpn = 0;
    let riun = 0;
    let rmcsa = 0;

    localIts.map((value) => {
      if (value.rlikes) {
        rlikes += parseInt(value.rlikes);
      }
      if (value.rhits) {
        rhits += parseInt(value.rhits);
      }
      if (value.rpn) {
        rpn += parseInt(value.rpn);
      }
      if (value.riun) {
        riun += parseInt(value.riun);
      }

      return true;
    });

    const total = { rlikes, rhits, rpn, riun, rmcsa };
    setTotals(total);
  }, [setTotals]);

  const getRemixParsAndSetCurrentIt = useCallback(async (it) => {
    if (it && it.rid) {
      toggleLoading(true);
      try {
        const response = await PSO.getRemixPars({
          un: authenticated.un,
          al: authenticated.al,
          rid: it.rid,
          getinputusers: 1,
          getrnphotos: 1
        });

        if (response.result === 'success' && response.its && response.its.length > 0) {
          setCurrentIt(response.its[0]);
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_request');
          console.error(message);
          setCurrentIt(it);
        }
      } catch (err) {
        console.error(Strings('general_error'));
      }
      toggleLoading(false);
    }
  }, [setCurrentIt, authenticated, toggleLoading]);

  const changeIt = useCallback((evt) => {
    setSelectedOption(evt);
    if (its && its.length > 0) {
      const selectedIts = its.filter((value) => {
        if (value.rid === evt.value) {
          return value;
        }
        return false;
      });
      if (selectedIts && selectedIts.length > 0) {
        getRemixParsAndSetCurrentIt(selectedIts[0]);
      } else {
        setCurrentIt();
      }
    }
  }, [setSelectedOption, its, setCurrentIt, getRemixParsAndSetCurrentIt]);

  const loadLists = useCallback((localIts, rid) => {
    setIts(localIts);
    let optionsToSet = localIts.map((value) => {
      return {
        value: value.rid,
        label: value.rti
      };
    });
    const allOption = { value: '0', label: 'ALL' };
    optionsToSet = [allOption, ...optionsToSet];
    setOptions(optionsToSet);

    if (rid) {
      const itemToSet = optionsToSet.filter((value) => value.value === rid);
      setSelectedOption(itemToSet);
      if (localIts && localIts.length > 0) {
        const selectedIts = localIts.filter((value) => {
          if (value.rid === rid) {
            return value;
          }
          return false;
        });
        if (selectedIts && selectedIts.length > 0) {
          getRemixParsAndSetCurrentIt(selectedIts[0]);
        }
      }
    } else {
      setSelectedOption(allOption);
    }

    loadCounters(localIts)
  }, [setOptions, setSelectedOption, loadCounters, getRemixParsAndSetCurrentIt]);

  const getVideos = useCallback(async () => {
    const urlParameterRid = query.get('rid');

    toggleLoading(true);

    try {
      const response = await PSO.getRemixListByCollection({
        un: authenticated.un,
        al: authenticated.al,
        colid: currentCampaign.colid
      });

      if (response.result === 'success') {
        loadLists(response.its, urlParameterRid);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [authenticated, toggleLoading, loadLists, currentCampaign, query]);

  useEffect(() => {
    getVideos();
  }, [getVideos]);

  return (
    <Card className="mb-3">
      <CardHeader className="card-header-tab z-index-6">
        <div className="card-header-title font-size-lg text-transform-none font-weight-normal">
          Video(s):
          <span className="d-inline-block ml-2" style={{ width: 250 }}>
            <Select
              value={selectedOption}
              onChange={changeIt}
              options={options}
            />
          </span>
        </div>
      </CardHeader>

      {selectedOption && selectedOption.value === '0' && (
        <AnalyzeGeneral
          totals={totals}
          its={its}
        />
      )}

      {selectedOption && selectedOption.value !== '0' && (
        <AnalyzeSpecific
          currentIt={currentIt}
        />
      )}

    </Card>
  );
}
